"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosSupplierOrderSchema = exports.APosSupplierReorderItemSchema = exports.APosSupplierOrderStatusSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
/**
 * Module 29 — Oil Blending (Phase 3)
 *
 * SupplierOrder — persisted log of every reorder placed through the supplier
 * adapter hooks in oil-blending-service.
 *
 * Table layout (provisioned by infrastructure/dynamodb-agenticpos):
 *   PK = tenantId
 *   SK = orderId  (`sup_<TENANT6>_<base36-ts>_<rand6>`)
 *
 * Multi-tenant: tenantId is the PK so every Query is tenant-isolated. There
 * is NO GSI for cross-tenant reads — by design.
 *
 * Lifecycle:
 *   - Row written by POST /reorder-alerts/{alertId}/place-supplier-order.
 *   - Status can later be refreshed by polling adapter.getStatus(externalOrderId).
 *   - Rows are append-only; updates rewrite the row in-place.
 *
 * Note: this is a P3 LOG table — the real source of truth for live order
 * status is the external supplier's API. We store the snapshot we got at
 * the moment we placed the order so the operator has an audit trail.
 */
exports.APosSupplierOrderStatusSchema = zod_1.z.enum([
    'submitted',
    'confirmed',
    'picking',
    'shipped',
    'delivered',
    'cancelled',
    'failed',
]);
exports.APosSupplierReorderItemSchema = zod_1.z.object({
    itemId: zod_1.z.string().min(1),
    sku: zod_1.z.string().optional(),
    name: zod_1.z.string().min(1),
    quantity: zod_1.z.number().nonnegative(),
    unit: zod_1.z.string().optional(),
    unitCostCents: zod_1.z.number().int().nonnegative().optional(),
});
exports.APosSupplierOrderSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    orderId: zod_1.z.string().min(1),
    supplierId: zod_1.z.string().min(1),
    supplierDisplayName: zod_1.z.string().min(1),
    /** The reorder-alert row that triggered this order (optional — manual reorders may have none). */
    alertId: zod_1.z.string().optional().nullable(),
    /** ISO-8601 timestamp when the order was placed via the adapter. */
    placedAt: zod_1.z.string().min(1),
    status: exports.APosSupplierOrderStatusSchema,
    items: zod_1.z.array(exports.APosSupplierReorderItemSchema).default([]),
    rejectedItems: zod_1.z
        .array(zod_1.z.object({
        item: exports.APosSupplierReorderItemSchema,
        reason: zod_1.z.string().min(1),
    }))
        .default([]),
    externalOrderId: zod_1.z.string().nullable(),
    expectedDelivery: zod_1.z.string().nullable().optional(),
    totalCents: zod_1.z.number().int().nonnegative().default(0),
    message: zod_1.z.string().nullable().optional(),
    success: zod_1.z.boolean(),
});
//# sourceMappingURL=supplier-order.schema.js.map